import Image from "next/legacy/image";
import styled from 'styled-components';

export const StyledNextImage = styled(Image)`
  image-rendering: auto;
`;
